'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var defineProperty = require('../../defineProperty-3cad0327.js');

function makeMergeMatchingProperties() {
  var strict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (baseValues, newValues) {
    return Object.keys(baseValues).reduce(function (accValues, key) {
      if (strict) {
        var newValue = newValues[key];
        return newValue ? _extends._extends_1({}, accValues, defineProperty.defineProperty({}, key, newValue)) : accValues;
      }

      return _extends._extends_1({}, accValues, defineProperty.defineProperty({}, key, newValues[key] || baseValues[key]));
    }, {});
  };
}

var mergeMatchingProperties = makeMergeMatchingProperties(false);
var strictlyMergeMatchingProperties = makeMergeMatchingProperties(true);

exports.mergeMatchingProperties = mergeMatchingProperties;
exports.strictlyMergeMatchingProperties = strictlyMergeMatchingProperties;
//# sourceMappingURL=mergeMatchingProperties.js.map
